import { useRef } from 'react';
import { Modal, ModalContent } from '@nextui-org/react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { Crown } from 'lucide-react';

import { GET_ME } from '../graphql/queries';
import { trackEvent } from '../utils/gt';
import { trialContext } from '../utils/subscription';

export const ModalUpgradePro = ({ isOpen, onOpenChange, onClose, title, description, onDismiss, backdrop, videoSrc }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const videoRef = useRef(null);
  // Already loaded by the page underneath; only decides whether the button offers the trial
  const { data: dataMe } = useQuery(GET_ME, { fetchPolicy: 'cache-first' });

  const handleCanPlay = () => {
    if (videoRef.current) {
      videoRef.current.muted = true;
      videoRef.current.play().catch(() => {});
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      placement="center"
      backdrop={backdrop === 'transparent' ? 'transparent' : 'opaque'}
      hideCloseButton
      classNames={{ base: 'mt-root mt-dialog mt-promo', backdrop: 'mt-dialog__backdrop' }}
    >
      <ModalContent>
        {() => (
          <>
            {/* A short recording of the feature in the app (MP4 everywhere: lighter than a GIF, and it plays inline on phones) */}
            {videoSrc && (
              <div className="mt-promo__media" aria-hidden="true">
                <video ref={videoRef} src={videoSrc} autoPlay muted loop playsInline onCanPlay={handleCanPlay} />
              </div>
            )}
            <div className="mt-dialog__body mt-promo__body">
              <h2 className="mt-dialog__title">
                {title || t('components.ModalUpgradePro.title')}
                <span className="mt-promo__badge">
                  <Crown aria-hidden="true" />
                  Pro
                </span>
              </h2>
              <p className="mt-dialog__text">{description || t('components.ModalUpgradePro.desc')}</p>
              <div className="mt-promo__actions">
                <button
                  type="button"
                  className="mt-btn mt-btn--primary"
                  onClick={() => {
                    trackEvent('modal_upgrade_pro_cta', 'Modal Upgrade Pro - CTA', 'modal_upgrade_pro', true);
                    onClose();
                    navigate('/plans');
                  }}
                >
                  {t('components.ModalUpgradePro.cta', { context: trialContext(dataMe?.me) })}
                </button>
                <button
                  type="button"
                  className="mt-btn mt-btn--quiet"
                  onClick={() => {
                    onClose();
                    onDismiss && onDismiss();
                  }}
                >
                  {t('components.ModalUpgradePro.dismiss')}
                </button>
              </div>
            </div>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
